import './LegalPages.css';

export default function TermsPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <a href="/" className="legal-back">← Back to Home</a>
        
        <h1>Terms of Service</h1>
        <p className="legal-updated">Last updated: March 2026</p>

        <section>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By installing and using Nexus AI Recommendations ("the App"), you agree to be bound by 
            these Terms of Service. If you do not agree to these terms, do not install or use the App.
          </p>
        </section>

        <section>
          <h2>2. Description of Service</h2>
          <p>
            Nexus AI Recommendations is a Shopify application that provides AI-powered product 
            recommendation widgets for your online store. The service includes:
          </p>
          <ul>
            <li>Customizable recommendation widgets</li>
            <li>Machine learning-based product suggestions</li>
            <li>Analytics and performance tracking</li>
            <li>Customer behavior analysis</li>
          </ul>
        </section>

        <section>
          <h2>3. Account and Access</h2>
          <p>
            To use the App, you must have a valid Shopify store. You are responsible for maintaining 
            the security of your Shopify account credentials. You agree to notify us immediately of 
            any unauthorized access.
          </p>
        </section>

        <section>
          <h2>4. Subscription and Billing</h2>
          <p>
            The App offers different subscription tiers with varying features. Billing is processed 
            through Shopify's billing system. By subscribing to a paid plan, you authorize Shopify 
            to charge your payment method on a recurring basis.
          </p>
          <h3>4.1 Free Trial</h3>
          <p>
            New users receive a 30-day free trial of the Professional plan. No credit card is required 
            to start the trial. At the end of the trial, you may choose to subscribe or continue with 
            the free Starter plan.
          </p>
          <h3>4.2 Cancellation</h3>
          <p>
            You may cancel your subscription at any time through the Shopify admin. Access to paid 
            features will continue until the end of the current billing period.
          </p>
        </section>

        <section>
          <h2>5. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Use the App for any unlawful purpose</li>
            <li>Attempt to reverse engineer or extract source code</li>
            <li>Interfere with or disrupt the App's functionality</li>
            <li>Use the App to transmit malware or harmful code</li>
            <li>Resell or redistribute the App without authorization</li>
          </ul>
        </section>

        <section>
          <h2>6. Intellectual Property</h2>
          <p>
            The App, including its design, code, and content, is owned by us and protected by 
            intellectual property laws. You receive a limited, non-exclusive license to use the 
            App for your Shopify store.
          </p>
        </section>

        <section>
          <h2>7. Disclaimer of Warranties</h2>
          <p>
            THE APP IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. WE DO NOT GUARANTEE THAT 
            THE APP WILL BE UNINTERRUPTED, ERROR-FREE, OR THAT IT WILL MEET YOUR SPECIFIC REQUIREMENTS. 
            RESULTS MAY VARY DEPENDING ON YOUR STORE, PRODUCTS, AND CUSTOMER BASE.
          </p>
        </section>

        <section>
          <h2>8. Limitation of Liability</h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR ANY INDIRECT, 
            INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING FROM YOUR USE OF THE APP, 
            INCLUDING BUT NOT LIMITED TO LOST PROFITS OR BUSINESS INTERRUPTION.
          </p>
        </section>

        <section>
          <h2>9. Modifications</h2>
          <p>
            We reserve the right to modify these Terms at any time. We will notify you of significant 
            changes via email or in-app notification. Continued use after changes constitutes acceptance.
          </p>
        </section>

        <section>
          <h2>10. Termination</h2>
          <p>
            We may terminate or suspend your access to the App for violation of these Terms or for 
            any other reason at our discretion. Upon termination, your right to use the App ceases immediately.
          </p>
        </section>

        <section>
          <h2>11. Contact</h2>
          <p>
            For questions about these Terms, contact us at:<br />
            <strong>Email:</strong> <a href="mailto:support@shopicraft-solutions.com">support@shopicraft-solutions.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}
